import { useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const ProjectManagementTabContent = () => {
    const intl = useIntl();

    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.projManagement.card.linkText",
        defaultMessage: "Try it out"
    });

    const cardDataEventProps: DataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };

    return (
        <TabsContent
            className="homepage-tabs-content"
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.header",
                        defaultMessage: "Perfect your project management"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.bodytext",
                        defaultMessage:
                            "Plan, track, and measure any project - from simple to complex - to ensure a smooth delivery."
                    })
                }
            ]}
            contentLink={{
                linkText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.projManagement.learnMore",
                    defaultMessage: "Learn more about Project Management"
                }),
                // TODO: verify this link
                link: useLocalizedHref("/solutions/itsm"),
                linkLabel: "Learn more about Project Management",
                productKey: "home"
            }}
            pictureProps={{
                image: {
                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/projm-main.webp",
                    // TODO: verify if image decorative or alt text needed
                    alt: "",
                    height: 400,
                    width: 768
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "HomePageTemplateV2.tab.projManagement.resources",
                defaultMessage: "Get started with a template"
            })}
            cardsContent={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card1.headerText",
                        defaultMessage: "Scrum"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card1.bodyText",
                        defaultMessage:
                            "Easily plan, track, and manage work across sprints"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            // TODO: verify with the team if this is the correct link
                            href: useLocalizedHref(
                                "/forrester/wave-enterprise-service-management"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/projm-card-1.webp",
                            // TODO: add alt text here or just decorative?
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card2.headerText",
                        defaultMessage: "Kanban"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card2.bodyText",
                        defaultMessage:
                            "Manage a continuous delivery of work on a collaborative board"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            // TODO: verify with the team if this is the correct link
                            href: useLocalizedHref(
                                "/forrester/wave-enterprise-service-management"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/projm-card-2.webp",
                            // TODO: add alt txt or image just decorative?
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card3.headerText",
                        defaultMessage: "Gantt chart"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card3.bodyText",
                        defaultMessage:
                            "Visualize timelines, progress, tracking, and dependencies"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            // TODO: verify with the team if this is the correct link
                            href: useLocalizedHref(
                                "/forrester/wave-enterprise-service-management"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/projm-card-3.webp",
                            // TODO: add alt txt or image just decorative?
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                }
            ]}
        />
    );
};

export { ProjectManagementTabContent };
